import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SidebarModule } from 'ng-sidebar';
import { Ng2SearchPipeModule } from 'ng2-search-filter';

import { DatePipe } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignInComponent } from './components/auth/pages/sign-in/sign-in.component';
import { SideNavComponent } from './components/sidenav/sidenav.component';
// import { CreateBatchComponent } from './components/sidenav/pages/create-batch/create-batch.component';
// import { ListOfChallansComponent } from './components/sidenav/pages/list-of-challans/list-of-challans.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { OtpComponent } from './components/auth/pages/otp/otp.component';
import { ForgotPasswordComponent } from './components/auth/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/pages/reset-password/reset-password.component';
// import { ViewChallanComponent } from './components/sidenav/pages/view-challan/view-challan.component';
// import { ViewSingleChallanComponent } from './components/sidenav/pages/view-single-challan/view-single-challan.component';
import { OnboardContainerComponent } from './components/sidenav/pages/onboard-container/onboard-container.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxPrinterModule } from "ngx-printer";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { ChangePasswordComponent } from './components/auth/pages/change-password/change-password.component';
import { SortModule } from './directive/sort/sort.module';
// import { ModalModule } from 'ngx-bootstrap';
import { QRCodeModule } from 'angular2-qrcode';
import { NgxPrintModule } from 'ngx-print';
import {InactivityTimerComponent} from './inactivity-timer.component'

import { EncrDecrService } from '../../src/service/encr-decr.service';
import { SuperAdminComponent } from './components/sidenav/pages/super-admin/super-admin.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SamplesPendingComponent } from './components/sidenav/pages/lab-analyst/samples-pending/samples-pending.component';
import { UploadResultComponent } from './components/sidenav/pages/lab-analyst/upload-result/upload-result.component';
import { ViewSamplesPendingComponent } from './components/sidenav/pages/lab-analyst/view-samples-pending/view-samples-pending.component';
import { SearchBySequencePipe } from './search-by-sequence.pipe';
import { ScanQrComponent } from './components/sidenav/pages/lab-analyst/scan-qr/scan-qr.component';
import { ChartsModule } from 'ng2-charts';
import { AuthInterceptor } from 'src/service/auth.interceptor';
import { CreateBatchComponent } from './components/sidenav/pages/create-batch/create-batch.component';
import { DisableCopyPasteModule } from './directives/disable-copy-paste/disable-copy-paste.module';
import { MustMatchDirective } from './helpers/must-match.directive';

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    InactivityTimerComponent,
    SideNavComponent,
    // ListOfChallansComponent,
    OtpComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    // ViewChallanComponent,
    // ViewSingleChallanComponent,
    OnboardContainerComponent,
    ChangePasswordComponent,
    SuperAdminComponent,
    SamplesPendingComponent,
    UploadResultComponent,
    ViewSamplesPendingComponent,
    SearchBySequencePipe,
    ScanQrComponent,
    CreateBatchComponent,
    MustMatchDirective,

  ],
  imports: [
    BrowserModule,
    DisableCopyPasteModule,
    SortModule,
    ChartsModule,
    AppRoutingModule,

    Ng2SearchPipeModule,
    NgxSpinnerModule,
    NgbModule,
    NgxPrinterModule.forRoot({
      printOpenWindow: false,
      renderClass: "custom-print",
      printPreviewOnly: false
    }),
    ReactiveFormsModule, FormsModule,HttpClientModule,
    SidebarModule.forRoot(),
    NgxPaginationModule,
    QRCodeModule,NgxPrintModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [DatePipe,EncrDecrService ,   { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },],
  bootstrap: [AppComponent],
  exports:[InactivityTimerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
